function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon",
  d: "M0.765335 1.71467L10.7653 7.08667C11.1013 7.26667 11.536 7.352 11.9733 7.352C12.4107 7.352 12.8453 7.26667 13.1813 7.08667L23.1813 1.71467C23.8333 1.364 24.4493 0 23.2533 0H0.694669C-0.501331 0 0.114669 1.364 0.765335 1.71467ZM23.484 4.652L13.1813 10.0213C12.728 10.2587 12.4107 10.2867 11.9733 10.2867C11.536 10.2867 11.2187 10.2587 10.7653 10.0213C10.312 9.784 1.25467 5.036 0.514669 4.65067C-0.00533112 4.37867 2.15475e-06 4.69733 2.15475e-06 4.94267V14.6667C2.15475e-06 15.2267 0.754669 16 1.33334 16H22.6667C23.2453 16 24 15.2267 24 14.6667V4.944C24 4.69867 24.0053 4.38 23.484 4.652Z",
  fill: "white"
});

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.b8d66378.svg";
export { ForwardRef as ReactComponent };